/* ═══ نقل ودجت عروض الكمية (Vitals Volume Discounts) لفوق عند زرار الشراء ═══
   Vitals بيحقن الودجت متأخر وفي الشريط اللاصق تحت. إحنا بننقلها جوّه صندوق
   معلومات المنتج فوق «أضف إلى السلة».
   بنستعمل مراقب DOM + بولينج قصير مع بعض: المراقب لوحده مش مضمون لأن Vitals
   ممكن يحقن جوّه shadow/iframe wrapper أو بعد ما المراقب يتفصل. */
(function () {
  'use strict';

  /* Vitals بيحقن عنصرين: المحتوى الحقيقي + منطقة تحميل فاضية بارتفاع 210px.
     بننقل المحتوى بس — منطقة التحميل كانت بتسيب فراغ أبيض كبير. */
  var SEL = '[class*="vtl-ub-vd-widget__content"], [class*="vtl-ub-vd-widget"]:not([class*="loading"])';
  var DEADLINE = 20000; // البولينج بيتجدّد كل ما بوب-أب يفتح // بنبطّل ندوّر بعد 20 ثانية
  var started = Date.now();

  function anchor() {
    /* لو في بوب-أب عرض سريع مفتوح، هو الأولوية */
    var modal = document.querySelector('.modal__content, [class*="quick-view"], [class*="quickview"]');
    if (modal && modal.getBoundingClientRect().height > 200) {
      var mBtns = modal.querySelector('.product-form__buttons') || modal.querySelector('product-form');
      if (mBtns) return mBtns;
    }
    var info = document.querySelector('.product__info-container');
    if (!info) return null;
    return info.querySelector('.product-form__buttons')
        || info.querySelector('product-form')
        || null;
  }

  function place() {
    var target = anchor();
    if (!target || !target.parentElement) return false;

    var widgets = document.querySelectorAll(SEL);
    var moved = false;

    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      if (w.parentElement === target.parentElement && w.nextElementSibling === target) continue;
      w.classList.add('hc-vd-placed');
      target.parentElement.insertBefore(w, target);
      moved = true;
    }
    return moved;
  }

  function loop() {
    place();
    if (Date.now() - started < DEADLINE) setTimeout(loop, 400);
  }

  function start() {
    if (!document.querySelector('.product__info-container')) return;

    loop();

    try {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; place(); });
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* البولينج بيغطّي */ }

    // Vitals بيعيد الرسم بعد تغيير الـvariant — نرجع ندوّر شوية تاني
    document.addEventListener('click', function () { started = Date.now(); }, true);
    document.addEventListener('change', function () {
      started = Date.now() - (DEADLINE - 5000);
      setTimeout(place, 300);
    }, true);
  }

  window.__hcVdPlace = place; // hook للتشخيص

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
